import { Image, Text, UnstyledButton } from '@mantine/core'
import React from 'react'
import CHECKICON from '../../images/CHECKICON.svg'
import COINICON from '../../images/COINICON.svg'
interface IQuizTimelineSpot {
    stepspot: number
    active: number
}
const QuizTimelineSpot = ({ stepspot, active }: IQuizTimelineSpot) => {
    const bg =
        stepspot === active
            ? 'black'
            : stepspot < active
            ? 'fuchasia.4'
            : 'gray.2'
    const passed = <Image w={20} mx='auto' src={CHECKICON} />
    const notpassed = (
        <Text mx='auto' w='100%' ta='center' c='text.1' fz={20} fw='bold'>
            {stepspot}
        </Text>
    )
    const actived = (
        <Image
            pos='absolute'
            top='-40%'
            left='-20%'
            w={65}
            mx='auto'
            src={COINICON}
        />
    )

    const insideButton =
        stepspot === active ? actived : stepspot < active ? passed : notpassed

    return (
        <UnstyledButton
            pos='relative'
            w={50}
            h={50}
            bg={bg}
            style={{ borderRadius: '100px' }}
        >
            {insideButton}
        </UnstyledButton>
    )
}

export default QuizTimelineSpot
